export default __webpack_public_path__ + "media/images/features/ja/house-38beb7b29861c34454e60069fd9a371e.png";